"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var pv_crypto_1 = require("./pv-crypto");
var util_1 = require("./util");
var nacl = require("tweetnacl");
var nacl_sealedbox = require("tweetnacl-sealedbox-js");
var NaclCryptoClass = /** @class */ (function () {
    function NaclCryptoClass() {
    }
    Object.defineProperty(NaclCryptoClass.prototype, "ivLength", {
        get: function () { return 24; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NaclCryptoClass.prototype, "tagLength", {
        get: function () { return 16; },
        enumerable: true,
        configurable: true
    });
    NaclCryptoClass.prototype.generateSymmKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, util_1.randomBytes(32)];
            });
        });
    };
    NaclCryptoClass.prototype.generateAsymmKey = function (usage, key) {
        return __awaiter(this, void 0, void 0, function () {
            var entropy, pair, pair;
            return __generator(this, function (_a) {
                entropy = key || util_1.randomBytes(32);
                if (usage === pv_crypto_1.PVCryptoUsage.ENCRYPT) {
                    pair = nacl.box.keyPair.fromSecretKey(entropy);
                    return [2 /*return*/, [pair.secretKey, pair.publicKey]];
                }
                else {
                    pair = nacl.sign.keyPair.fromSeed(entropy);
                    return [2 /*return*/, [entropy, pair.publicKey]];
                }
                return [2 /*return*/];
            });
        });
    };
    NaclCryptoClass.prototype.symmetricEncrypt = function (key, iv, plaintext) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                result = nacl.secretbox(plaintext, iv, key);
                // Return ciphertext, tag
                return [2 /*return*/, [result.slice(16), result.slice(0, 16)]];
            });
        });
    };
    NaclCryptoClass.prototype.symmetricDecrypt = function (key, iv, tag, ciphertext) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, nacl.secretbox.open(util_1.concatArrays(tag, ciphertext), iv, key)];
            });
        });
    };
    NaclCryptoClass.prototype.sharedSecret = function (privateKey, publicKey, _useFipsDerivation) {
        if (_useFipsDerivation === void 0) { _useFipsDerivation = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, nacl.box.before(publicKey, privateKey)];
            });
        });
    };
    NaclCryptoClass.prototype.boxEncrypt = function (privateKey, publicKey, plaintext, _useFipsDerivation) {
        if (_useFipsDerivation === void 0) { _useFipsDerivation = false; }
        return __awaiter(this, void 0, void 0, function () {
            var nonce, ciphertext;
            return __generator(this, function (_a) {
                nonce = util_1.randomBytes(nacl.box.nonceLength);
                ciphertext = nacl.box(plaintext, nonce, publicKey, privateKey);
                return [2 /*return*/, util_1.concatArrays(nonce, ciphertext)];
            });
        });
    };
    NaclCryptoClass.prototype.boxDecrypt = function (privateKey, publicKey, encryptedResult, _useFipsDerivation) {
        if (_useFipsDerivation === void 0) { _useFipsDerivation = false; }
        return __awaiter(this, void 0, void 0, function () {
            var nonce, ciphertext;
            return __generator(this, function (_a) {
                nonce = encryptedResult.slice(0, nacl.box.nonceLength);
                ciphertext = encryptedResult.slice(nacl.box.nonceLength);
                return [2 /*return*/, nacl.box.open(ciphertext, nonce, publicKey, privateKey)];
            });
        });
    };
    NaclCryptoClass.prototype.hybridEncrypt = function (publicKey, plaintext, _useFipsDerivation) {
        if (_useFipsDerivation === void 0) { _useFipsDerivation = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, nacl_sealedbox.seal(plaintext, publicKey)];
            });
        });
    };
    NaclCryptoClass.prototype.hybridDecrypt = function (privateKey, ciphertext, _useFipsDerivation, publicKey) {
        if (_useFipsDerivation === void 0) { _useFipsDerivation = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = publicKey;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.publicKeyFromPrivate(privateKey, pv_crypto_1.PVCryptoUsage.ENCRYPT)];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        publicKey = _a;
                        return [2 /*return*/, nacl_sealedbox.open(ciphertext, publicKey, privateKey)];
                }
            });
        });
    };
    NaclCryptoClass.prototype.sign = function (seed, message) {
        return __awaiter(this, void 0, void 0, function () {
            var pair;
            return __generator(this, function (_a) {
                pair = nacl.sign.keyPair.fromSeed(seed);
                return [2 /*return*/, nacl.sign.detached(message, pair.secretKey)];
            });
        });
    };
    NaclCryptoClass.prototype.publicKeyFromPrivate = function (privateKey, usage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (usage === pv_crypto_1.PVCryptoUsage.SIGN) {
                    return [2 /*return*/, nacl.sign.keyPair.fromSeed(privateKey).publicKey];
                }
                else {
                    return [2 /*return*/, nacl.box.keyPair.fromSecretKey(privateKey).publicKey];
                }
                return [2 /*return*/];
            });
        });
    };
    NaclCryptoClass.prototype.verify = function (publicKey, message, signature) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, nacl.sign.detached.verify(message, signature, publicKey)];
            });
        });
    };
    return NaclCryptoClass;
}());
exports.NaclCryptoClass = NaclCryptoClass;
exports.NaclCrypto = new NaclCryptoClass();
